import React from 'react';
import { format, startOfWeek, addDays } from 'date-fns';
import es from 'date-fns/locale/es';

const NavigationWeek = ({ currentDate, onNavigate }) => {
    const startDate = startOfWeek(currentDate, { locale: es, weekStartsOn: 1 });
    const endDate = addDays(startDate, 4); // Suponiendo una semana laboral de 5 días

    return (
        <div className="d-flex justify-content-between align-items-center mb-4 nav-semana">
            <button onClick={() => onNavigate(-1)} className="btn btn-outline-secondary">
                <i className="bi bi-chevron-left"></i> Semana anterior
            </button>
            <h4 className="mb-0 text-center">
                Semana del {format(startDate, 'dd/MM/yyyy')} al {format(endDate, 'dd/MM/yyyy')}
            </h4>
            <button onClick={() => onNavigate(1)} className="btn btn-outline-secondary">
                Semana siguiente <i className="bi bi-chevron-right"></i>
            </button>
        </div>
    );
};

export default NavigationWeek;